// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"0aa1bfbd","431":"40003355","608":"1902d9b0","663":"12d40abb","787":"f44c65b9"}[chunkId] + ".chunk.js";
};